import React, { PropsWithChildren, useState } from "react";
import { ProjectLinkStyle as S } from "./ProjectLink.style";
import { useObservable } from "@rsm";
import { getClientService } from "services/client.service";
import { ApiSchema } from "@api-types";
import { ProjectLinkSurveyProcessingModal } from "./ProjectLinkSurveyProcessingModal/ProjectLinkSurveyProcessingModal";

export const getProjectLink = (
  project: Pick<ApiSchema.Project, "statusCode" | "id"> | Pick<ApiSchema.ProjectDto, "statusCode" | "id">,
  teamId?: number,
) => {
  const status = project?.statusCode || 0;
  const teamPath = teamId ? `/${teamId}/` : "";

  if (status === 50) return `${teamPath}projects/${project.id}/review`;
  if (status < 200) return `${teamPath}projects/${project.id}`;
  if (status < 400) return `${teamPath}project-surveys/${project.id}`;
  if (status >= 800) return `${teamPath}results/${project.id}`;
  return "#";
};

export const ProjectLink: React.FC<
  PropsWithChildren<{ projectId: number; statusCode: number; teamId?: number; className?: string }>
> = ({ projectId, statusCode, children, teamId: clientId, className }) => {
  const [visible, setVisible] = useState(false);
  const clientIdCur = useObservable(getClientService().defaultClientId$);
  const projectLink = getProjectLink({ statusCode, id: projectId });

  return (
    <>
      <S.ProjectLink
        className={className}
        to={`/${clientId ?? clientIdCur}/${projectLink}`}
        onClick={(e) => {
          if (statusCode < 500 && statusCode >= 400) {
            e.preventDefault();
            e.stopPropagation();
            setVisible(true);
          }
        }}
      >
        {children}
      </S.ProjectLink>
      {visible && (
        <ProjectLinkSurveyProcessingModal
          projectId={projectId}
          statusCode={statusCode}
          teamId={clientId}
          setVisible={setVisible}
        />
      )}
    </>
  );
};
